import React, { useState, useContext, useEffect } from 'react';
import { Button,  Form, FormField, Grid, Header, Icon, Image, Input, Label, Message,  Segment,  } from 'semantic-ui-react'


import {  getlinktournament } from '../../../../myfunctions';
import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';
import noimage from '../../../../assets/noimage.png';
import ShowPagination from '../../../../tools/ShowPagination';

function SearchTournamentTG() {

  const authContext = useContext(AuthContext);
  const [form, setForm] = useState({
    searchName: null,
  });

  const [limit, setlimit] = useState(false);// eslint-disable-line no-unused-vars



  const [loading, setloading] = useState(false);

  const [dataRowT, setdataRowT] = useState(null)



 

  useEffect(() => {
    setdataRowT(null)
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, []);// eslint-disable-line react-hooks/exhaustive-deps




  const submit = async e => {
    e.preventDefault();


    setloading(true)

    let searchName = form.searchName


    ConnectWS("/generator/findTournamentsBySubstring", authContext.token, { textSearch: searchName }, function (response, logout) {
      if (logout === 1) {
      } else if (response && response.status && Number(response.status) === 200) {

        //setForm({ ...form, searchName: "" })

        let tmparr = []

        if(response.data.played.length>0){
          response.data.played.forEach((row) => {
            tmparr.push({ ...row, finished:0 })
          })
        }

        if(response.data.finished.length>0){
          response.data.finished.forEach((row) => {
            tmparr.push({ ...row, finished:1 })
          })
        }
        tmparr.sort((a, b) => {
          return a.finished - b.finished || new Date(b.start_date) - new Date(a.start_date);
        })
       
        setdataRowT({ current: tmparr.slice(0, 3), filter: null, data: tmparr, activePage: 1 })

       
      } else {

        console.log(response);
      }
      setloading(false)
     
      

     
    });


  }


  function retTab(arr,setarr) {
    if (arr!=null && arr.data && arr.data.length > 0) {
      return <>
        <Header as='h4' block>
          Liczba znalezionych turniejów: {arr.data.length}
        </Header>
        {arr.current.map((row, i) =>
          <Segment key={i} raised  >
             <Label  color={row.finished===1 ? "grey" : "blue"}  ribbon style={{marginBottom:5}}>
          {row.finished===1 ? "ROZEGRANY" : "NOWY"}
        </Label>
            <Grid verticalAlign='middle' stackable divided>
              <Grid.Row>
                <Grid.Column width={3}>
                  <div style={{ width: "100%", height: 120,overflow:"hidden",position: "relative",borderRadius:5 }} >
                  <Image src={row.img_file ? row.img_file : noimage} rounded style={{ width: "100%",position: "absolute",top:"50%",transform:"translateY(-50%)"}} />
                  </div>
                </Grid.Column>
                <Grid.Column width={13}>
                  <Icon name="winner" color='grey' /> <b>{row.name}</b><br />
                  <Icon name="calendar" color='grey' /> {row.start_date}<br />
                  <Icon name="linkify" color='grey' /> {getlinktournament(row.tournament_id)}
                </Grid.Column>
              </Grid.Row>
            </Grid>


          </Segment>
        )}
        <ShowPagination myTab={arr} setMyTab={setarr} rowCurrent={3} darkOn={true} />
      
      </>
    } else {
      return <Message
        icon='info circle'
        header='Brak szykanych turniejów'
        content='Żaden turniej nie spełnia kryteriów wyszukiwania'
      />
    }
  }

 



  function setClearData(){
    setdataRowT(null)
  }


  return (
    <div>
      {(dataRowT) && !limit ? <>
        <Button size='mini' style={{ marginBottom: 10 }} onClick={() => setClearData()} fluid>WYSZUKAJ PONOWNIE</Button>
        {retTab(dataRowT,setdataRowT)}
      </> :
        <>
          <Form size='tiny' onSubmit={submit}>
            <FormField
              control={Input}
              
              label='Wpisz szukaną nazwę turnieju'
              value={form.searchName}
              onChange={(e, d) => setForm({ ...form, searchName: d.value })}
              required={true}
              placeholder='Wpisz szukaną nazwę turnieju'
            />
            <Button fluid loading={loading} disabled={loading} type='submit'>Szukaj</Button>
          </Form>
          {limit ? <>
            <Message
              icon='info circle'
              header='Znaleziono zbyt dużo turniejów'
              content='Dopisz więcej znaków w szukanym polu'
            />
          </> : ""}
        </>}
    </div>


  )
}

export default SearchTournamentTG;